import React, { useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { usePopup } from '../../context/PopupContext';
import { generateEntityLink as generateEntityLinkAction } from '../../services/actions/actions';
import copy from 'copy-to-clipboard';
import CopyToolTip from '../common/CopyToolTip';
import Loader from '../common/Loader';

import {
    EmailShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    TwitterShareButton,
    WhatsappShareButton
} from "react-share";

import NewTwitterLogoX from '../../assets/images/NewTwitterLogoX.svg';

import {
    EmailIcon,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    WhatsappIcon
} from "react-share";

const SharePopup = () => {
    const [entityLink, setEntityLink] = useState('');
    const {boxContent, close, status, rightCallbackAction, leftCallbackAction, data } =  usePopup();
    const [showCopyToolTip, setShowCopyToolTip] = useState(false);
    const dispatch = useDispatch();

    const handleCopy = () => {
        copy(entityLink)
    }

    const generateEntityLink = () => {
        setEntityLink(null); //Show loader till link fetched
        if (data.user) {
            dispatch(generateEntityLinkAction(data[data.entity.type], data.user.id, data.type, data.entity)).then(res => {
                // handle response
                if(res !== undefined){
                    const resp = JSON.parse(JSON.stringify(res))
                    setEntityLink(resp.link)
                }
            }).catch(e => {
                // handle error
                console.log(e);
            });
        } else {
            console.error("Share Popup: User data is null!");
        }
    }

    const ref = useRef(null);

    const getEntityLink = () => {
        const key_name = data.entity.type == 'resume' ? 'resume_link' : 'letter_link'
        if(!ref.current || ref.current != data[data.entity.type].id){
            ref.current = data[data.entity.type].id
            // if(data[data.entity.type]?.[key_name] && data[data.entity.type]?.[key_name] != '')
            //     setEntityLink(data[data.entity.type]?.[key_name]);
            // else
                generateEntityLink();
        }
    }

    const LinkedInShare = (url) => {
        if(url == '') return
        /**
         * `https://www.linkedin.com/shareArticle/?` doesn't work while sharing the app URL.
         * `https://www.linkedin.com/sharing/share-offsite/?` doesn't work while sharing the app URL.
         *  Therefore, used `https://www.linkedin.com/feed/shareArticle/?text=`. It seems to be working.
         *  Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/516
         *  Date: 2023-12-26
         */
        //const shareURL = `https://www.linkedin.com/shareArticle/?mini=true&url=${url}&title=Resume&summary=Resume&source=ResumeBuilder.com`
        //const shareURL = `https://www.linkedin.com/sharing/share-offsite/?mini=true&url=${url}&title=Resume&summary=Resume&source=ResumeBuilder.com`
        const shareURL = `https://www.linkedin.com/feed/?shareActive=true&text=${url}`
        window.open(shareURL, "mywin", "toolbar=yes,scrollbars=no,resizable=yes,top=330,left=600,width=530,height=430")
        return false
    }
    
    if(status('sharebox')) getEntityLink();

    return (<>
        {status('sharebox') && <><div className="transparent-popup-bg"></div>
        <div className="custom-skip-popup">
                <div className="close-btn-icon">
                <button
                    className="close-icon"
                    onClick={() => {
                        close();
                        localStorage.removeItem('entityLink');
                        ga4Track('app_share_popup_exit', 'RT App', 'Exit');
                    }}>Close</button>
            </div>
            <div className="content-box">
                <h4>Share Your {data.entity.name}</h4>
                {!entityLink 
                ? <Loader /> 
                : <><p>Share your {data.entity.name} on social media or copy the link to share via email or on your personal website.</p>
                <div className="copy-label">Copy this private URL</div>
                <div className="share-link">{entityLink}</div>
                <div className="share-icons-area">
                        <ul className="share-icons-list">
                        <li onClick={
                            () => ga4Track('app_share_popup_facebook', 'RT App', 'Facebook')
                        }>
                            <FacebookShareButton url={ entityLink } quote={`${data.entity.name} Builder`}>
                                <span className="share-icon">
                                <FacebookIcon size={40} round />
                                </span>
                            </FacebookShareButton>
                        </li>
                        <li onClick={
                            () => ga4Track('app_share_popup_linkedin', 'RT App', 'Linkedin')
                        }>
                            {/** 
                             * The URL share on LinkedIn doesn't work with `LinkedinShareButton`. Therefore, used the custom one.
                             * Only the home page is being shared on LinkedIn. Seems to be some issue with the resume link.
                             * Possible reason: Title and Description
                             * Ticket: https://gitlab.dailyrssmail.com/growthlabs/resumebuilder-app/-/issues/516
                             * Date: 2023-12-26
                             * */
                             }
                            {/* <LinkedinShareButton 
                                url={ entityLink }
                                title={ "Resume" }
                                summary={ "Resume" }
                                source={ `${data.entity.name} Builder` }
                            >
                                <span className="share-icon">
                                <LinkedinIcon size={40} round />
                                </span>
                            </LinkedinShareButton> */}
                            {/** The custom method to share the link on LinkedIn */}
                            <button quote="Resume Builder" aria-label="linkin" className="react-share__ShareButton" style={{cursor: "pointer", backgroundColor: "transparent", border: "none", padding: 0}}>
                            <span className="share-icon" onClick={(e) => {
                                LinkedInShare(entityLink)
                            }}>
                                <LinkedinIcon size={40} round />
                            </span>
                            </button>
                        </li>
                        <li onClick={
                            () => ga4Track('app_share_popup_twitter', 'RT App', 'Twitter')
                        }>
                            <TwitterShareButton url={ entityLink } quote={`${data.entity.name} Builder`}>
                                <span className="share-icon">
                                <NewTwitterLogoX />
                                </span>
                            </TwitterShareButton>
                        </li>
                    </ul>
                </div>
                <div className="button-area">
                    <a 
                        href={entityLink} 
                        target="_blank" 
                        className="no-skip button"
                        onClick={
                            () => ga4Track('app_share_popup_open_link', 'RT App', 'Open Link')
                        }>Open Link</a>
                    <button className="skip" onClick={() => {
                        handleCopy();
                        setShowCopyToolTip(true);
                        ga4Track('app_share_popup_copy_link', 'RT App', 'Copy Link')
                    }}>Copy Link</button>
                </div>
                {showCopyToolTip && 
                    <CopyToolTip 
                        showCopyToolTip={showCopyToolTip} 
                        setShowCopyToolTip={(showCopyToolTip) => setShowCopyToolTip(showCopyToolTip)} 
                    />
                }</>}
            </div>
        </div></>}
    </>)
}
export default SharePopup;

